const zh = {
	accountSet: '账户设置',
	pasdSet: '密码设置',
	langSet: '语言设置',
	selectLan: '选择界面语言',
	simplifiedChinese: '简体中文',
	changePassword: '修改密码',
	tipsChangePaswd: '修改密码时需要输入当前密码，如果你忘记了当前密码，可以',
	clickHere: '点击这里',
	retrievePassword: '找回密码',
	currentPassword: '当前密码',
	plCurrentPassword: '请输入当前密码',
	newPassword: '新密码',
	plNewPassword: '请输入新密码',
	confirmPassword: '确认密码',
	plConfirmPassword: '请再次输入新密码',
	plTwoPasswords: '两次输入密码不一致',
	saveSettings: '保存设置',
	setAvatar: '设置头像',
	plSetAvatar: '选择一张个人正面照片作为头像，企业成员可以更容易认识你',
	selectPhoto: '选择照片上传',
	personalData: '个人资料',
	codingSettings: '编码设置', //66
	prefix: '前缀',
	digitalLength: '数字长度',
	startingPosition: '起始位置',
	pleaseEnter: '请输入',
	numLengthTips: '数字长度应是3-10!',
	numberTips: '如：4，则是0000',
	numStartTips: '起始位置不能大于 数字长度!',
	numberPlaceholder: '如：10，则是从数字10开始进行编号，不能超过总长度。',
	getNum: '生成编码',
	example: '实例',
	forReferenceOnly: '仅供参考',
	accountSetting: '账号设置',
};
export default zh;
